module.exports = __webpack_public_path__ + "static/barchart-43771ad49fb34213651abc4f322d0eb4.png";